module.exports = __webpack_public_path__ + "static/4-a7ac3c055f29f8bc1cc9b613a28e6c3b.jpeg";